module.exports = __webpack_public_path__ + "36d6b53d.svg";